/**
 * @fileoverview Partner Selector View - Handles UI interactions for selecting a partner for a
 * social post.
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.social.post.PartnerSelectorView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Collection = goog.require('yext.mvc.Collection');
const Partner = goog.require('yext.social.post.Partner');
const PartnerIconView = goog.require('yext.social.post.PartnerIconView');

/** @constructor */
const PartnerSelectorView = function(options) {
  this.options = options || {};

  /** @type {!jQuery} */
  this.$el = this.options.$el || $('.js-post-partners-container');

  /** @type {Collection} */
  this.partners = new Collection(Partner)
    .init(this.options.partners || []);

  /**
   * @type {Function}
   * @private
   */
  this.onChange_ = null;

  /**
   * @private
   * @type {function(Partner, function)}
   * @param {function()} onSuccess
   */
  this.onSelectPartner_ = this.options.onSelectPartner;
};

/** @return this */
PartnerSelectorView.prototype.init = function() {
  this.initPartnerViews_();
  this.bindPartnerSelection_();
  this.setInitialAvailablePartners_();
  this.selectPreferredPartners_();
  return this;
};

/** @param {Function} cb */
PartnerSelectorView.prototype.onChange = function(cb) {
  if (!yext.isFunction(cb)) {
    throw new TypeError('PartnerSelectorView.onChange: Invalid cb, expected a function');
  }
  this.onChange_ = cb;
};

/** @return {!Object<string, ?>} */
PartnerSelectorView.prototype.getData = function() {
  return {
    'partnerIds': this.partners.getByAttribute('isSelected', true)
      .filter(function(partner) {
        return partner['isAvailable'] == true;
      })
      .map(function(partner) {
        return partner.get('id');
      }),
  };
};

/** Selects all available partners */
PartnerSelectorView.prototype.reset = function() {
  this.partners.each(function(partner) {
    partner.set('isSelected', true);
  });

  this.selectPreferredPartners_();
};

/** @param {!Object<string, ?>} data */
PartnerSelectorView.prototype.setAvailablePartners = function(data) {
  if (data == null) {
    this.setInitialAvailablePartners_();
    return;
  }

  this.partners.each(function(partner) {
    this.onSelectPartner_(partner, function() {
      var isAvailable = data['partners'].includes(partner.get('id'))
                        && (partner.get('id') != Partner.PartnerId.WIDGETS
                         || data['hasSocialWidgets']);
      partner.set({
        'isAvailable': isAvailable,
      });
    });
  }.bind(this));
};

/** @return {!Array<number>} the partners that are available for all entities in the business */
PartnerSelectorView.prototype.getAllAvailablePartnerIds = function() {
  return this.partners.filter(function(partner) {
    return this.options.postablePartners.includes(partner.get('id'));
  }.bind(this)).map(function(partner) {
    return partner.get('id');
  });
};

/** @param {!Array<number>} partnerIds */
PartnerSelectorView.prototype.setSelectedPartners = function(partnerIds) {
  partnerIds = partnerIds || [];
  this.partners.each(function(partner) {
    this.onSelectPartner_(partner, function() {
      partner.set('isSelected', partnerIds.includes(partner.get('id')));
    });
  }.bind(this));
};

/** @private */
PartnerSelectorView.prototype.initPartnerViews_ = function() {
  this.partners.each(function(partner) {
    new PartnerIconView(partner, this.onSelectPartner_)
      .init()
      .mount(this.$el);
  }.bind(this));
};

/** @private */
PartnerSelectorView.prototype.bindPartnerSelection_ = function() {
  this.partners.on('change:isSelected,change:isAvailable', function() {
    if (this.onChange_) {
      this.onChange_(this.getData());
    }
  }.bind(this));
};

/** @private */
PartnerSelectorView.prototype.setInitialAvailablePartners_ = function() {
  this.partners.each(function(partner) {
    this.onSelectPartner_(partner, function() {
      partner.set('isAvailable', this.options.postablePartners.includes(partner.get('id')));
    }.bind(this));
  }.bind(this));
};

/** @private */
PartnerSelectorView.prototype.selectPreferredPartners_ = function() {
  if (this.options.preferredPartners && this.options.preferredPartners.length > 0) {
    this.setSelectedPartners(this.options.preferredPartners);
  }
};

exports = PartnerSelectorView;
